import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // Client errors will not fix themselves; only retry network and server failures.
        retry: (count, error) =>
          !(error instanceof ApiError && error.status > 0 && error.status < 500) && count < 2,
        refetchOnWindowFocus: false,
        staleTime: 10_000,
      },
      mutations: { retry: false },
    },
  });
